import System from '@/modules/system/pages/system/systems.page.vue';
import SystemRegister from '@/modules/system/pages/system-register/systems-register.page.vue';

declare const process: any;

export const SYSTEM_ACCESS_ROUTES = Object.freeze({
    SYSTEM: 'systems-route',
    SYSTEM_REGISTER: 'systems-register',
});

export const systemRoutes = [
    {
        path: `${process.env.BASE_URL}system`,
        component: () => import('@/layout/default.layout.vue'),
        children: [
            {
                path: '',

                // name: SYSTEM_ACCESS_ROUTES.SYSTEM,
                component: System,
                meta: {
                    requiresAuth: true,
                },
                children: [
                    {
                        path: '',
                        // name: SYSTEM_ACCESS_ROUTES.SYSTEM_REGISTER,
                        component: SystemRegister,
                    },
                ],
            },
        ],
    },
];
